var _tspan, _tspan2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _tspan3, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 467.94 56.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-240.56 -428.16)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 254.28571,
    y: 438.07648,
    fill: "#000000",
    fontFamily: "Ubuntu",
    fontSize: "50px",
    fontWeight: 500,
    letterSpacing: "0px",
    strokeWidth: "1px",
    wordSpacing: "0px",
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 254.28571,
    y: 438.07648
  }))), /*#__PURE__*/React.createElement("text", {
    x: 414.28571,
    y: 578.07648,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "40px",
    letterSpacing: "0px",
    strokeWidth: "1px",
    wordSpacing: "0px",
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 414.28571,
    y: 578.07648
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m253.93 444.5v35.801l2.5884 2.547h27.111v-3.4553c-15.38-0.0285-26.236-7e-3 -26.236-7e-3v-34.885z",
    fill: "#0ea5e9",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m248.46 444.45v30.066l3.2842 3.6107v-33.676z",
    fill: "#0ea5e9",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m243.14 444.49v24.88l3.1418 2.9892 2.3e-4 -27.869z",
    fill: "#0ea5e9",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m287.02 468.48v-35.649l-2.5884-2.5471h-27.121v3.4553c15.38 0.0283 26.246 7e-3 26.246 7e-3v34.734z",
    fill: "#0ea5e9",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m292.68 468.45v-29.863l-3.2842-3.503v33.366z",
    fill: "#0ea5e9",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m298.28 468.47v-24.78l-3.1418-3.0753-2.2e-4 27.856z",
    fill: "#0ea5e9",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m259.35 477.4h24.253l-4.7e-4 -3.2047h-24.252z",
    fill: "#0ea5e9",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m259.34 471.86h24.253l-4.8e-4 -3.2046h-24.252z",
    fill: "#0ea5e9",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m257.4 444.3h24.28l-4.8e-4 -3.2047h-24.28z",
    fill: "#0ea5e9",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m257.39 438.96h24.281l-4.7e-4 -3.2047h-24.28z",
    fill: "#0ea5e9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("text", {
    x: 596.95911,
    y: 472.54541,
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "40px",
    letterSpacing: "0px",
    strokeWidth: "1px",
    wordSpacing: "0px",
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 596.95911,
    y: 472.54541
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m317.9 438.68q7.5 0 11.45 2.75 4 2.75 4 8.4 0 7.05-6.95 9.55 0.95 1.15 2.15 2.8t2.45 3.6q1.25 1.9 2.4 3.95 1.15 2 2.05 3.95h-7.05q-0.95-1.8-2.05-3.6-1.1-1.85-2.25-3.55-1.1-1.75-2.2-3.25-1.1-1.55-2.05-2.75-0.7 0.05-1.2 0.05t-0.95 0h-3.05v13.1h-6.3v-34.15q2.3-0.5 4.9-0.65 2.6-0.2 4.65-0.2zm0.45 5.45q-2 0-3.7 0.15v11.2h2.75q2.3 0 4.05-0.25t2.9-0.9q1.2-0.65 1.8-1.75t0.6-2.8q0-1.6-0.6-2.7t-1.75-1.75q-1.1-0.65-2.65-0.9-1.55-0.3-3.4-0.3z",
    fill: "#697274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.05 456.33q0 2.85 0.7 5.2 0.7 2.3 2 3.95 1.35 1.6 3.25 2.5t4.3 0.9q2.35 0 4.25-0.9t3.2-2.5q1.35-1.65 2.05-3.95 0.7-2.35 0.7-5.2t-0.7-5.15q-0.7-2.35-2.05-3.95-1.3-1.65-3.2-2.55t-4.25-0.9q-2.4 0-4.3 0.9t-3.25 2.55q-1.3 1.65-2 3.95t-0.7 5.15zm27.05 0q0 4.45-1.35 7.85-1.3 3.4-3.6 5.7-2.25 2.25-5.3 3.4t-6.5 1.15-6.55-1.15q-3.05-1.15-5.35-3.4-2.25-2.3-3.6-5.7t-1.35-7.85 1.35-7.8q1.35-3.4 3.65-5.7 2.35-2.3 5.4-3.45t6.45-1.15 6.45 1.15 5.3 3.45q2.3 2.3 3.65 5.7 1.35 3.35 1.35 7.8z",
    fill: "#697274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.87 468.98q3.4 0 4.95-1.15t1.55-3.25q0-1.25-0.55-2.15-0.5-0.9-1.5-1.6-0.95-0.75-2.35-1.35-1.4-0.65-3.2-1.25-1.8-0.65-3.5-1.4-1.65-0.8-2.95-1.95-1.25-1.15-2.05-2.75-0.75-1.6-0.75-3.85 0-4.7 3.25-7.35 3.25-2.7 8.85-2.7 3.25 0 5.75 0.75 2.55 0.7 4 1.55l-1.95 5.1q-1.7-0.95-3.75-1.45-2-0.5-4.15-0.5-2.55 0-4 1.05-1.4 1.05-1.4 2.95 0 1.15 0.45 2 0.5 0.8 1.35 1.45 0.9 0.65 2.05 1.2 1.2 0.55 2.6 1.05 2.45 0.9 4.35 1.85 1.95 0.9 3.25 2.2 1.35 1.25 2.05 3 0.7 1.7 0.7 4.15 0 4.7-3.35 7.3-3.3 2.55-9.7 2.55-2.15 0-3.95-0.3-1.75-0.25-3.15-0.65-1.35-0.4-2.35-0.8-1-0.45-1.6-0.8l1.85-5.15q1.35 0.75 3.65 1.5t5.55 0.75z",
    fill: "#697274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.82 468.98q3.4 0 4.95-1.15t1.55-3.25q0-1.25-0.55-2.15-0.5-0.9-1.5-1.6-0.95-0.75-2.35-1.35-1.4-0.65-3.2-1.25-1.8-0.65-3.5-1.4-1.65-0.8-2.95-1.95-1.25-1.15-2.05-2.75-0.75-1.6-0.75-3.85 0-4.7 3.25-7.35 3.25-2.7 8.85-2.7 3.25 0 5.75 0.75 2.55 0.7 4 1.55l-1.95 5.1q-1.7-0.95-3.75-1.45-2-0.5-4.15-0.5-2.55 0-4 1.05-1.4 1.05-1.4 2.95 0 1.15 0.45 2 0.5 0.8 1.35 1.45 0.9 0.65 2.05 1.2 1.2 0.55 2.6 1.05 2.45 0.9 4.35 1.85 1.95 0.9 3.25 2.2 1.35 1.25 2.05 3 0.7 1.7 0.7 4.15 0 4.7-3.35 7.3-3.3 2.55-9.7 2.55-2.15 0-3.95-0.3-1.75-0.25-3.15-0.65-1.35-0.4-2.35-0.8-1-0.45-1.6-0.8l1.85-5.15q1.35 0.75 3.65 1.5t5.55 0.75z",
    fill: "#697274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m454.28 468.23v5.45h-21.9v-34.65h6.3v29.2h15.6z",
    fill: "#697274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.23 456.33q0 2.85 0.7 5.2 0.7 2.3 2 3.95 1.35 1.6 3.25 2.5t4.3 0.9q2.35 0 4.25-0.9t3.2-2.5q1.35-1.65 2.05-3.95 0.7-2.35 0.7-5.2t-0.7-5.15q-0.7-2.35-2.05-3.95-1.3-1.65-3.2-2.55t-4.25-0.9q-2.4 0-4.3 0.9t-3.25 2.55q-1.3 1.65-2 3.95t-0.7 5.15zm27.05 0q0 4.45-1.35 7.85-1.3 3.4-3.6 5.7-2.25 2.25-5.3 3.4t-6.5 1.15-6.55-1.15q-3.05-1.15-5.35-3.4-2.25-2.3-3.6-5.7t-1.35-7.85 1.35-7.8q1.35-3.4 3.65-5.7 2.35-2.3 5.4-3.45t6.45-1.15 6.45 1.15 5.3 3.45q2.3 2.3 3.65 5.7 1.35 3.35 1.35 7.8z",
    fill: "#697274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512.35 443.78q-5.35 0-8.2 3.35-2.8 3.3-2.8 9.2 0 2.8 0.65 5.15 0.7 2.3 2 3.95 1.35 1.65 3.3 2.6 2 0.9 4.65 0.9 1.65 0 2.85-0.1 1.2-0.15 1.9-0.35v-12.45h6.3v16.65q-1.3 0.5-4.4 1.1t-7.15 0.6q-3.75 0-6.85-1.2t-5.3-3.5q-2.15-2.3-3.35-5.65t-1.2-7.7 1.3-7.7q1.35-3.35 3.65-5.65 2.3-2.35 5.4-3.55t6.6-1.2q2.4 0 4.25 0.35 1.9 0.3 3.25 0.7t2.2 0.85q0.9 0.45 1.25 0.65l-1.9 5.15q-1.5-0.9-3.75-1.5-2.2-0.65-4.65-0.65z",
    fill: "#697274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m553.33 473.68q-0.7-2.05-1.45-4.05t-1.45-4.1h-14.6q-0.7 2.1-1.45 4.15-0.7 2-1.4 4h-6.55q1.95-5.55 3.7-10.25t3.4-8.9q1.7-4.2 3.35-8t3.4-7.5h5.95q1.75 3.7 3.4 7.5t3.3 8q1.7 4.2 3.45 8.9 1.8 4.7 3.75 10.25h-6.8zm-10.2-27.95q-1.15 2.65-2.65 6.45-1.45 3.8-3.05 8.25h11.4q-1.6-4.45-3.1-8.3t-2.6-6.4z",
    fill: "#697274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m587.86 473.68q-1.7-2.85-3.8-6.1-2.1-3.3-4.35-6.6-2.25-3.35-4.6-6.45-2.3-3.15-4.4-5.65v24.8h-6.2v-34.65h5.15q2 2.1 4.3 5 2.3 2.85 4.6 5.95 2.35 3.1 4.5 6.25 2.2 3.1 3.9 5.8v-23h6.25v34.65h-5.35z",
    fill: "#697274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m623.72 442.93q0.8 2.7 1.7 5.65 0.9 2.9 1.85 5.85 1 2.9 1.95 5.75 1 2.8 1.9 5.3 0.75-2.7 1.45-5.85 0.7-3.2 1.4-6.6 0.7-3.45 1.35-7 0.7-3.55 1.3-7h6.5q-1.75 9.4-3.9 18.1-2.15 8.65-4.8 16.55h-6q-3.9-10.1-7.55-22.05-1.85 6.05-3.75 11.5t-3.8 10.55h-6q-2.7-7.9-4.85-16.55-2.1-8.7-3.85-18.1h6.75q0.6 3.4 1.25 6.95 0.7 3.55 1.4 7 0.75 3.4 1.5 6.6t1.5 5.9q0.95-2.55 1.9-5.35 1-2.85 1.95-5.75 0.95-2.95 1.8-5.85 0.9-2.9 1.65-5.6h5.4z",
    fill: "#e8eaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m648.39 439.03v5.3535c7.9261-6.9e-4 16.505-2e-3 23.457-2e-3v-5.3516zm0 14.523v5.2617c7.2215-1e-3 15.073-4e-3 21.429-4e-3v-5.25c-7.0303 9e-3 -14.795-9e-3 -21.429-8e-3zm0 14.771v5.3555h23.449v-5.3496c-7.691 7e-3 -16.164-7e-3 -23.449-6e-3z",
    fill: "#e8eaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m688.14 474.08q-2.75 0-5.55-0.2-2.8-0.15-4.9-0.7v-33.65q1.1-0.2 2.35-0.35 1.25-0.2 2.55-0.3t2.55-0.15q1.3-0.05 2.45-0.05 3.15 0 5.85 0.5 2.7 0.45 4.65 1.55 2 1.1 3.1 2.9t1.1 4.45q0 2.45-1.2 4.2-1.15 1.75-3.25 2.8 3.15 1.05 4.65 3.1t1.5 5.2q0 5.35-3.9 8.05-3.9 2.65-11.95 2.65zm-4.25-16v10.55q1.05 0.1 2.25 0.15t2.2 0.05q1.95 0 3.6-0.25 1.7-0.25 2.9-0.85 1.25-0.65 1.95-1.7 0.75-1.05 0.75-2.7 0-2.95-2.15-4.1t-5.95-1.15h-5.55zm0-4.95h4.45q3.6 0 5.65-1 2.05-1.05 2.05-3.7 0-2.5-2.15-3.55-2.1-1.05-5.5-1.05-1.45 0-2.6 0.05-1.1 0.05-1.9 0.15v9.1z",
    fill: "#e8eaea"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 647.06,
    y: 444.4,
    opacity: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.39995c4fef4bf737711a879d967a8f2a.svg";
export { ForwardRef as ReactComponent };